export const scramble = (code: string): string => {
  if (code.length !== 5) throw new Error('Dodo code must be exactly 5 characters long')

  const salt = Array.from({ length: 5 }, () => Math.floor(Math.random() * 256))
  const encrypted = salt.map((byte, i) => byte ^ code.charCodeAt(i))
  const toHex = (bytes: number[]) => bytes.map((b) => b.toString(16).padStart(2, '0')).join('')

  return toHex(salt) + toHex(encrypted)
}

export const unscramble = (code: string): string => {
  if (code.length !== 20) throw new Error('Invalid code length')

  const match = code.match(/.{1,2}/g)
  if (!match) throw new Error('Invalid code format')

  const bytes = match.map((h) => parseInt(h, 16))
  const salt = bytes.slice(0, 5)
  const encrypted = bytes.slice(5, 10)
  const decrypted = encrypted.map((byte, i) => byte ^ salt[i]!)

  return String.fromCharCode(...decrypted)
}
